import { addNode } from '../RicosContentAPI/builder-utils.js';
import '../Either-48abb652.js';
import '../ReadonlyNonEmptyArray-0e481d0b.js';
import 'lodash';
import '../fp-utils-24a5cc96.js';
import '../RicosContentAPI/modify.js';
import 'ricos-schema';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../converters/generateRandomId.js';

class Builder {
  constructor(content, onRender) {
    this.content = content;
    this.onRender = onRender;
  }
  add(addNodeParams) {
    this.content = addNode(addNodeParams);
    return this;
  }
  append(node) {
    return this.add({ node, content: this.content });
  }
  insertBefore(id, node) {
    return this.add({ node, content: this.content, before: id });
  }
  insertAfter(id, node) {
    return this.add({ node, content: this.content, after: id });
  }
  insertAt(index, node) {
    return this.add({ node, content: this.content, index });
  }
  render() {
    var _a;
    (_a = this.onRender) == null ? void 0 : _a.call(this, this.content);
    return this.content;
  }
}
const createBuilder = (content, onRender) => new Builder(content, onRender);

export { createBuilder };
//# sourceMappingURL=builder.js.map
